import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/pages/products/use-cases/car01.jpeg")